// extracted by mini-css-extract-plugin
module.exports = {"quickGuide":"QuickGuide_quickGuide__YStb4"};